"use client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
//import "react-toastify/dist/ReactToastify.css";
import { useBookingEngineContext } from "../cin_context/BookingEngineContext";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

import { X } from "lucide-react";

const RoomManager = ({backgroundColor, initialAdults, initialChildren}) => {
  const {childAge, setChildAge, selectedRooms, setSelectedRooms, setSelectedRoom ,setSelectedRoomDetails,selectedInitialRoom, setSelectedInitialRoom, 
    isRatePing, setRatePing,
    //maxGuestAllowed, setMaxGuestAllowed
  } =
    useBookingEngineContext();
  const [isToggled, setIsToggled] = useState(false);
  const containerRef = useRef(null);

  const rooms = useMemo(() => selectedRooms || [], [selectedRooms]);

  // Ensure default room with 1 adult

  useEffect(() => {
    if (rooms.length === 0) {
      const id = uuidv4();
      const adults = Math.min(7, Math.max(1, parseInt(initialAdults, 10) || 2));
      const children = Math.min(2, Math.max(0, parseInt(initialChildren, 10) || 0));
      setSelectedRooms([{ id: id, adults, children, childAges: []}]);
      setSelectedRoom([
        {
          id: id,
          roomId: "",
          roomName: "",
          roomRate: "",
          roomImage: {},
          adults,
          children, 
          childAges: []
        },
      ]);
    }
  }, [rooms, setSelectedRooms, initialAdults, initialChildren]);

  const updateChildAge = (roomId, childIndex, age) => {

    setSelectedRooms(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            const childAges = [...room.childAges];
            childAges[childIndex] = age;

            return {
                ...room,
                childAges
            };
        })
    );

    setSelectedRoom(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            const childAges = [...room.childAges];
            childAges[childIndex] = age;

            return {
                ...room,
                childAges
            };
        })
    );
};

  const addRoom = () => {
    if (rooms.length < 10) {
      if(rooms.length > 1){
      setRatePing(false);
      }else{
      setRatePing(true);
      }
      const id = uuidv4();
      setSelectedRooms((prev) => [...prev, { id: id, adults: 2, children: 0, childAges: [] }]);
      setSelectedRoom((prev) => [
        ...prev,
        {
          id: id,
          roomId: "",
          roomName: "",
          roomRate: "",
          roomImage: {},
          adults: 2,
          children: 0, 
          childAges: []
        },
      ]);
    } else {
      toast.error("Maximum of 4 rooms can be added.");
    }
  };

  // const updateRoom = (roomId, type, value) => {
  //   if (type !== "adults" && type !== "children") {
  //     console.error("Invalid type:", type);
  //     return;
  //   }

  //   setSelectedRooms((prev) =>
  //     prev.map((room) =>
  //       room.id === roomId
  //         ? {
  //             ...room,
  //             [type]:
  //               type === "adults" ? Math.max(1, value) : Math.max(0, value),
  //           }
  //         : room
  //     )
  //   );

  //   setSelectedRoom((prev) =>
  //     prev.map((room) =>
  //       room.id === roomId
  //         ? {
  //             ...room,
  //             [type]:
  //               type === "adults" ? Math.max(1, value) : Math.max(0, value),
  //           }
  //         : room
  //     )
  //   );
  // };

  const updateRoom = (roomId, type, value) => {
    setSelectedRooms(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            if (type === "children") {

                const children = Math.max(0, value);

                let childAges = [...room.childAges];

                // Add empty age entries
                while (childAges.length < children)
                    childAges.push("");

                // Remove extra ages
                while (childAges.length > children)
                    childAges.pop();

                return {
                    ...room,
                    children,
                    childAges
                };
            }

            return {
                ...room,
                adults: Math.max(1, value)
            };
        })
    );

    setSelectedRoom(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            if (type === "children") {

                const children = Math.max(0, value);

                let childAges = [...room.childAges];

                while (childAges.length < children)
                    childAges.push("");

                while (childAges.length > children)
                    childAges.pop();

                return {
                    ...room,
                    children,
                    childAges
                };
            }

            return {
                ...room,
                adults: Math.max(1, value)
            };
        })
    );
};

  const removeRoom = (roomId) => {
    setSelectedRoomDetails(null);
    setSelectedRooms((prev) => prev.filter((rooms) => rooms.id !== roomId));
    setSelectedRoom((prev) => prev.filter((room) => room.id !== roomId));
    
  };

  const totalAdults = rooms.reduce((sum, room) => sum + room.adults, 0);
  const totalChildren = rooms.reduce((sum, room) => sum + room.children, 0);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        !event.target.closest(".form-control")
      ) {
        setIsToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeRoomChange = () => {
   setIsToggled(false);
  };
  
  return (
    <div className="mb-3 mb-md-0">
      <div className="book-room my-0">
        <button
          type="button"
          className="form-control"
          aria-expanded={isToggled}
          onClick={(e) => {
            e.stopPropagation();
            const buttonRect = e.currentTarget.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            const shouldOpenUp = viewportHeight - buttonRect.bottom < 300; // adjust threshold
            setIsToggled((prev) => !prev);

            setTimeout(() => {
              const dropdown = document.getElementById("roomsDropdown");
              if (dropdown) {
                if (shouldOpenUp) {
                  dropdown.classList.add("open-up");
                } else {
                  dropdown.classList.remove("open-up");
                }
              }
            }, 0);
          }}
        >
          {`${totalAdults} Adult, ${totalChildren} Children - ${rooms.length} Room`}
        </button>

        {isToggled && (
          <div className="roomsDropdown" id="roomsDropdown">
            
            <div className="card card-body" ref={containerRef}>
              <div className="position-relative child-room-cross-btn">
                <div
                  className="room-manager-close-icon fw-bold text-center rounded shadow-sm"
                  style={{backgroundColor: backgroundColor || "#f26624" }}
                  onClick={closeRoomChange}
                >
                  <X size={20} strokeWidth={2} className="pointer-events-none" />{" "}
                </div>
              </div>
              
              {rooms.map((room, index) => (
                <div key={room.id} className="room mb-3 border-bottom pb-2">
                  <div className="d-flex justify-content-between align-items-start">
                    <p className="fw-bold">{`Room ${index + 1}`}</p>
                    {rooms.length > 1 && (
                      <button
                        onClick={() => removeRoom(room.id)}
                        className="btn-close remove-room"
                      >
                        x
                      </button>
                    )}
                  </div>
                  <div className="row m-0">
                    <div className="col-6 px-2">
                      <div className="d-flex align-items-center justify-content-evenly">
                        <button
                          onClick={() =>
                            updateRoom(room.id, "adults", room.adults - 1)
                          }
                          className="btn btn-outline-secondary btn-minus"
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                        <span className="form-control text-center mx-0 adult-count">{`Adults: ${room.adults}`}</span>
                        <button
                          className="btn btn-outline-secondary btn-plus"
                          onClick={() =>
                            updateRoom(room.id, "adults", room.adults + 1)
                          }
                          disabled={room.adults >= 7}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </div>
                   
                    <hr className="vertical-hr"></hr>
                    <div className="col-6 px-2">
                      <div className="d-flex align-items-center justify-content-evenly">
                        <button
                          className="btn btn-outline-secondary btn-minus"
                          onClick={() =>
                            updateRoom(room.id, "children", room.children - 1)
                          }
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                        <div className="flex-column">
                          <span className="form-control d-inline-block text-center mx-0 child-count">{`Children: ${room.children}`}</span>
                          <span className="age-count">(0 - {childAge} yrs)</span>
                        </div>
                        <button
                          className="btn btn-outline-secondary btn-plus"
                          onClick={() =>
                            updateRoom(room.id, "children", room.children + 1)
                          }
                          disabled={room.children >= 2}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </div>
                     
                  </div>
                

{room.children > 0 && (
  <div className="child-age-container">
    {room.childAges.map((age, childIndex) => {
const ageOptions = [
  { value: "", label: "Select Age", isDisabled: true },
  ...Array.from({ length: childAge + 1 }, (_, i) => ({
    value: i,
    label: i.toString(),
  })),
];
    
  return (   
  <div className="child-age-item" key={childIndex}>
    <label className="child-age-label">
        Child {childIndex + 1} Age <span className="text-danger">*</span>
    </label>

    <Select
  className="child-age-select"
  classNamePrefix="child-age"
  isSearchable={false}
  options={ageOptions}
  // placeholder="Select Age"
  value={
  age === "" || age === undefined
    ? ageOptions[0]
    : ageOptions.find(o => o.value === Number(age))
}
  onChange={(selectedOption) =>
    updateChildAge(
      room.id,
      childIndex,
      selectedOption ? selectedOption.value : ""
    )
  }

  menuPortalTarget={document.body}
  menuPosition="fixed"
  isOptionDisabled={(option) => option.isDisabled}

  styles={{
  control: (base, state) => ({
    ...base,
    minHeight: 28,
    height: 28,
    borderColor: backgroundColor || "#f26624",
    boxShadow: state.isFocused
      ? `0 0 0 1px ${backgroundColor || "#f26624"}`
      : "none",
    "&:hover": {
      borderColor: backgroundColor || "#f26624",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    height: 28,
    padding: "0 8px",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: 28,
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),

  menu: (base) => ({
    ...base,
    zIndex: 99999,
    width: "100%",
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? backgroundColor || "#f26624"
      : state.isFocused
      ? backgroundColor || "#f26624"
      : "#fff",
    color:
      state.isSelected || state.isFocused
        ? "#fff"
        : "#333",
    cursor: "pointer",
  }),
}}
/>
</div>)
})}
  </div>
)}
                </div>
              ))}
              <button
                className="btn btn-link add-room"
                onClick={addRoom}
                disabled={rooms.length >= 10}
              >
                + Add Another Room
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default RoomManager;
